import { DatePipe } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { LineAsset } from '@models/dashboard.model';
import { TranslationService } from '@services/translation/translation.service';
import { BaseBadgeComponent } from '@shared-components/badge/base-badge/base-badge.component';

@Component({
  selector: 'ts-eligibility-badge',
  templateUrl: './eligibility-badge.component.html',
  imports: [BaseBadgeComponent],
  providers: [DatePipe]
})
export class EligibilityBadgeComponent {
  @HostBinding('class') classes: string = 'd-contents';
  @Input() line: LineAsset;
  @Input() class: string = '';

  constructor(
    private date_pipe: DatePipe,
    private translation_svc: TranslationService
  ) {}

  display(): boolean {
    return Boolean(
      this.line?.id && (this.line?.upgrade_eligibility || this.line?.upgrade_eligible_date)
    );
  }

  text(): string {
    return this.line?.upgrade_eligibility
      ? this.translation_svc.translate('upgrade_eligible')?.toUpperCase()
      : this.translation_svc
          .translate(
            'upgrade_input',
            this.date_pipe.transform(this.line.upgrade_eligible_date, 'MM/dd/yyyy') ?? undefined
          )
          ?.toUpperCase();
  }
}
